import {fi} from "date-fns/locale";

class PlainTextEdit extends HTMLElement {
    private editor: HTMLDivElement;
    constructor() {
        super()

        this.attachShadow({ mode: "open" })
        this.shadowRoot!.innerHTML = `
            <style>
                div {
                    /* Use the custom CSS property */
                    color: var(--custom-color, black);
                }
            </style>
            <div contenteditable="true" style="border: 1px solid #000; padding: 10px; background: red; width: 200px; height: 50px"></div>
        `

        this.editor = this.shadowRoot!.querySelector("div")!

        // Add classes from the host element to the <div>
        this.editor.className = this.className

        this.editor.addEventListener("input", () => {
            const selection = window.getSelection()
            if (!selection) {
                throw new Error("Input selection was null in shadow root")
            }
            const range = selection.getRangeAt(0)
            const bookmark = range.cloneRange()

            const text = this.editor.innerText
            this.editor.innerText = text

            const firstChild = this.editor.firstChild
            if (!firstChild) throw new Error("First child was null")
            bookmark.setStart(firstChild, bookmark.startOffset)
            bookmark.setEnd(firstChild, bookmark.endOffset)
            selection.removeAllRanges()
            selection.addRange(bookmark)
        })
    }

    // Update the class when attribute changes
    attributeChangedCallback(name : string, oldValue : string, newValue : string) {
        if (name === "class") {
            this.editor.className = newValue
        }
    }

    static get observedAttributes() {
        return ["class"]
    }
}

window.customElements.define("plain-text-edit", PlainTextEdit)
